import React from 'react';
import SectionComponent from "./SectionComponent";
import { IMG_DESIGN_COORD } from "../../data/constructionServiceImages";

function DesignCoordination() {
  return (
    <SectionComponent
      images={IMG_DESIGN_COORD}
      titles={{
        mainTitle: "Design coordination",
        subTitle: "Protecting design intent through delivery",
        sectionTitle1: "RFIs & submittals",
        sectionTitle2: "Site communication",
        sectionTitle3: "Change control",
        sectionTitle4: "Project photography",
      }}
      descriptions={{
        sectionDescription1: "We channel architect and consultant questions into a clear RFI rhythm so decisions are traceable, dated, and distributed to affected trades.",
        sectionDescription2: "Site meetings focus on coordination: what is being built this week, what interfaces are at risk, and what the design team needs to confirm.",
        sectionDescription3: "Variations are scoped with programme impact visible—so clients and architects can choose consciously between cost, time, and design outcomes.",
        imageAlt: "Construction coordination and site delivery"
      }}
      galleryLink="/projects/commercial"
      seo={{
        title: "Design coordination",
        description: "Design coordination and communication for architects during construction delivery. MA Renovations."
      }}
    />
  )
}

export default DesignCoordination;
